import { System } from '../core/index.js';
import { MaterialLibrary } from './library.js';

/** Boots and owns the shared procedural material library before visual systems construct meshes. */
export class MaterialsSystem extends System {
  static id = 'materials';
  static deps = ['render'];
  static budgetMs = 0;

  constructor() {
    super();
    this.library = null;
  }

  async init(ctx) {
    const quality = ctx.config.quality;
    const highResolution = ctx.config.presetName === 'high' || ctx.config.presetName === 'ultra';
    this.library = new MaterialLibrary({
      size: highResolution ? 128 : 64,
      anisotropy: quality.anisotropy,
    }).bake();
    const stats = this.library.stats();
    ctx.data.materials = this.library;
    ctx.metrics.setCounter('materials.textureBytes', stats.textureBytes);
    ctx.metrics.setCounter('materials.recipes', stats.recipes);
    ctx.log.info(
      `materials: ${stats.recipes} coherent surfaces, ` +
      `${(stats.textureBytes / 1048576).toFixed(2)} MiB baked textures`,
    );
  }

  material(kind, options) {
    if (!this.library) throw new Error('materials: library is not ready.');
    return this.library.material(kind, options);
  }

  stats() {
    return this.library ? this.library.stats() : null;
  }

  dispose() {
    if (this.library) this.library.dispose();
    this.library = null;
  }
}
